import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setStepOneformData as setFormData } from '../store';

const Step1ConnectShopify = ({ onNext }) => {
    const formData = useSelector((state) => state.analysisData.stepOneformData);

    const dispatch = useDispatch();

    // const [formData, setFormData] = useState({
    //     TYPE: "shopify",
    //     SHOPIFY_SHOP: "",
    //     SHOPIFY_ACCESS_TOKEN: "",
    //     SHOPIFY_API_VERSION: "",
    //     FROM_DATE: "",
    //     END_DATE: "",
    //     SHOPIFY_NO_OF_ORDERS: ""
    // });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const errorArray = [
        "TYPE",
        "SHOPIFY_SHOP",
        "SHOPIFY_ACCESS_TOKEN",
        "SHOPIFY_API_VERSION",
        "SHOPIFY_NO_OF_ORDERS"
    ]

    const handleChange = (e) => {
        const value = e.target.value;
        const key = e.target.name;

        dispatch(setFormData({
            ...formData,
            [key]: value
          }));
          
    }

    const handleConnect = () => {
        const newErrors = {};

        for (const field of errorArray) {
            if (!formData[field] || formData[field] === "") {
                // Convert field names like SHOPIFY_SHOP to "Shopify Shop"
                const label = field
                    .replace(/_/g, ' ')
                    .toLowerCase()
                    .replace(/\b\w/g, (l) => l.toUpperCase());

                newErrors[field] = `${label} is required!`;
            }
        }

        // If any errors, stop and set them
        if (Object.keys(newErrors).length > 0) {
            setError(newErrors);
            setTimeout(()=>{
                setError({});
            },2000)
            return;
        }
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            onNext();
        }, 1000);
    };

    return (
        <div className="bg-white rounded-xl shadow-md p-8 mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-6 flex items-center">
                <i className="fas fa-store mr-3 text-indigo-500"></i> Connect Your Shopify Store
            </h2>
            <div className="grid md:grid-cols-2 gap-8">
                <div>
                    <div className="mb-6">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Shopify Store URL
                        </label>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <span className="text-gray-500">https://</span>
                            </div>
                            <input
                                type="text"
                                value={formData.SHOPIFY_SHOP}
                                name="SHOPIFY_SHOP"
                                onChange={handleChange}
                                className={`pl-16 block w-full rounded-md border ${error.SHOPIFY_SHOP ? "border-red-500" : "border-gray-300"
                                    } shadow-sm focus:border-indigo-500 focus:ring-indigo-500 py-2 px-3`}
                                placeholder="yourstore.myshopify.com"
                            />
                        </div>
                        {error.SHOPIFY_SHOP && (
                            <p className="mt-1 text-sm text-red-600">{error.SHOPIFY_SHOP}</p>
                        )}
                    </div>

                    <div className="mb-6">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Shopify Access Token
                        </label>
                        <input
                            type="password"
                            value={formData.SHOPIFY_ACCESS_TOKEN}
                            name="SHOPIFY_ACCESS_TOKEN"
                            onChange={handleChange}
                            className={`block w-full rounded-md border ${error.SHOPIFY_ACCESS_TOKEN ? "border-red-500" : "border-gray-300"
                                } shadow-sm focus:border-indigo-500 focus:ring-indigo-500 py-2 px-3`}
                            placeholder="Your Shopify Access Token"
                        />
                        {error.SHOPIFY_ACCESS_TOKEN && (
                            <p className="mt-1 text-sm text-red-600">{error.SHOPIFY_ACCESS_TOKEN}</p>
                        )}
                    </div>

                    <div className="mb-6">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Shopify API Version
                        </label>
                        <select
                            value={formData.SHOPIFY_API_VERSION}
                            name="SHOPIFY_API_VERSION"
                            onChange={handleChange}
                            className={`block w-full rounded-md border ${error.SHOPIFY_API_VERSION ? "border-red-500" : "border-gray-300"
                                } shadow-sm focus:border-indigo-500 focus:ring-indigo-500 py-2 px-3 bg-white`}
                        >
                            <option value="">Select version</option>
                            <option value="2025-04">2025-04</option>
                            <option value="2025-01">2025-01</option>
                            <option value="2024-10">2024-10</option>
                            <option value="2024-07">2024-07</option>
                            <option value="2024-04">2024-04</option>
                            <option value="2024-01">2024-01</option>
                            <option value="2023-10">2023-10</option>
                        </select>
                        {error.SHOPIFY_API_VERSION && (
                            <p className="mt-1 text-sm text-red-600">{error.SHOPIFY_API_VERSION}</p>
                        )}
                    </div>



                </div>
                <div>
                <div className="mb-6">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Shopify No. Of Orders
                        </label>
                        <input
                            type="number"
                            min={100}
                            name="SHOPIFY_NO_OF_ORDERS"
                            value={formData.SHOPIFY_NO_OF_ORDERS}
                            onChange={handleChange}
                            placeholder="Enter number of orders"
                            className={`block w-full rounded-md border ${error.SHOPIFY_NO_OF_ORDERS ? "border-red-500" : "border-gray-300"
                                } shadow-sm focus:border-indigo-500 focus:ring-indigo-500 py-2 px-3 bg-white`}
                        />
                        {error.SHOPIFY_NO_OF_ORDERS && (
                            <p className="mt-1 text-sm text-red-600">{error.SHOPIFY_NO_OF_ORDERS}</p>
                        )}
                    </div>

                    {/* <div className="mb-6">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Type
                        </label>
                        <select
                            value={formData.TYPE}
                            // onChange={(e) => setStartDate(e.target.value)}
                            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 py-2 px-3 border bg-white"
                        >
                            <option value="shopify">shopify</option>
                        </select>
                    </div> */}
                    <div className="mb-6">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Start Date</label>
                        <input
                            type="date"
                            value={formData.FROM_DATE}
                            name='FROM_DATE'
                            onChange={(e) => handleChange(e)}
                            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 py-2 px-3 border"
                        />
                    </div>
                    <div className="mb-6">
                        <label className="block text-sm font-medium text-gray-700 mb-1">End Date</label>
                        <input
                            type="date"
                            value={formData.END_DATE}
                            name='END_DATE'
                            onChange={(e) => handleChange(e)}
                            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 py-2 px-3 border"
                        />
                    </div>
                    {/* <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
                        <div className="flex">
                            <i className="fas fa-info-circle text-blue-500 mt-1 mr-3"></i>
                            <div>
                                <h3 className="text-sm font-medium text-blue-800">
                                    Need help finding your API credentials?
                                </h3>
                                <p className="mt-1 text-sm text-blue-700">
                                    Go to your Shopify admin, then navigate to Apps &gt; Develop apps &gt; Your app &gt; API credentials.
                                </p>
                            </div>
                        </div>
                    </div> */}
                    <div className="flex justify-end">
                        <button
                            onClick={handleConnect}
                            disabled={loading}
                            className="bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-6 rounded-md flex items-center"
                        >
                            {loading ? <i className="fas fa-spinner fa-spin mr-2" /> : <>Connect <i className="fas fa-arrow-right ml-2" /></>}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Step1ConnectShopify;
